import { useState } from 'react'
import './addCourseTopic.scss'
import InputWithoutBorder from '../../components/input-field-no-border/InputWithoutBorder'
import Button from '../../components/button/Button'
import deleteIcon from '../../assets/icons/deleteFill.svg'
import arrowDownIcon from '../../assets/icons/arrow-down.svg'
import CustomTabs from '../../components/Tabs/Tabs'
import AddTopicDetails from './AddTopicDetails'
import { useDispatch } from 'react-redux'
import { deleteModulesAndTopics, deleteUploadedDocument } from '../../store/builders/course/course.builder'
import { useParams } from 'react-router-dom'
import { UI_CONSTANT } from '../../utility/constants'

function AddCourseTopic({ values, setFieldValue, index, moduleIndex, remove }) {
  const [showUploadTab, setShowUploadTab] = useState(false)
  const dispatch = useDispatch()
  const { id } = useParams()

  const handleRemoveFiles = (fieldName, fileIndex, moduleIndex, fileName, s3Url, currentTopicId) => {
    const updatedFiles = values.modules[moduleIndex].topic[index][fieldName].filter((_, i) => i !== fileIndex)
    setFieldValue(`modules[${moduleIndex}].topic[${index}].${fieldName}`, updatedFiles)
    id && dispatch(deleteUploadedDocument({ fileName, s3Url, currentTopicId }))
  }

  const handleRemoveMcqFiles = (fileName, currentTopicId, s3Url) => {
    setFieldValue(`modules[${index}].topic[${index}].mcqFile`, [])
    id && dispatch(deleteUploadedDocument({ fileName, currentTopicId, s3Url }))
  }

  let currentTopicId = id ? values?.modules[moduleIndex]?.topic[index]?.topicId : ''


  const handleFileChange = (event, index, fieldName, allowedMimeTypes, maxFiles = Infinity) => {
    const files = Array.from(event.currentTarget.files)
    const currentFiles = values.modules[moduleIndex].topic[index][fieldName] || []

    const newFiles = files.filter((file) => {
      const isDuplicate = currentFiles.some((currentFile) => currentFile.name === file.name)
      // const isValidFileType = allowedMimeTypes.includes(file.type)
      const isValidFileType =
      allowedMimeTypes.includes(file.type) || // Check allowed MIME types
      (file.type === '' && file.name.toLowerCase().endsWith('.zip')) || // Fallback for undefined MIME type
      ['application/x-zip-compressed', 'application/zip'].includes(file.type); // Handle specific zip MIME types
      
      const isValidFileName = /^[a-zA-Z0-9 .]+$/.test(file.name);


      if (!isValidFileName) {
        alert(`File "${file.name}" has invalid characters in its name. Please rename it and try again.`);
      }


      return !isDuplicate && isValidFileType && isValidFileName
    })
    if (fieldName === 'mcqFile') {
      return setFieldValue(`modules[${moduleIndex}].topic[${index}].${fieldName}`, [...newFiles])
    }
    setFieldValue(
      `modules[${moduleIndex}].topic[${index}].${fieldName}`,
      [...currentFiles, ...newFiles].slice(0, maxFiles),
    )
  }

  const tabs = [
    {
      label: 'Learning material PDF',
      tabContent: (
        <AddTopicDetails
          moduleIndex={moduleIndex}
          index={index}
          fieldName='pdfFiles'
          values={values}
          onChange={(event) => handleFileChange(event, index, 'pdfFiles', ['application/pdf', 'application/zip', 'application/x-zip-compressed'])}
          handleRemoveFiles={(fileIndex, fileName, s3Url, currentTopicId) =>
            handleRemoveFiles('pdfFiles', fileIndex, moduleIndex,  fileName, s3Url,currentTopicId)
          }
        />
      ),
    },
    {
      label: 'Video Lecture',
      tabContent: (
        <AddTopicDetails
          moduleIndex={moduleIndex}
          index={index}
          fieldName='videoFiles'
          values={values}
          onChange={(event) =>
            handleFileChange(event, index, 'videoFiles', ['video/mp4', 'video/mpeg', 'video/quicktime'])
          }
          handleRemoveFiles={(fileIndex, fileName, s3Url, currentTopicId) =>
            handleRemoveFiles('videoFiles', fileIndex, moduleIndex, fileName, s3Url, currentTopicId)
          }
        />
      ),
    },
    {
      label: 'Exam dataset',
      tabContent: (
        <AddTopicDetails
          moduleIndex={moduleIndex}
          index={index}
          fieldName='mcqFile'
          values={values}
          onChange={(event) =>
            handleFileChange(
              event,
              index,
              'mcqFile',
              ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
              1,
            )
          }
          handleRemoveFiles={(_, fileName,s3Url, currentTopicId) => {
            handleRemoveMcqFiles(fileName, currentTopicId, s3Url)
          }}
        />
      ),
    },
  ]

  const handleShowUploadTab = () => {
    setShowUploadTab((showUploadTab) => {
      return !showUploadTab
    })
  }

  return (
    <div className='add-topic-container'>
      <InputWithoutBorder
        inputTitle={'Topic:'}
        name={`modules[${moduleIndex}].topic[${index}].topicName`}
        placeholder={'Enter topic name...'}
        required={true}
      >
        {showUploadTab ? (
          <img className='arrow-close-upload' src={arrowDownIcon} onClick={handleShowUploadTab} />
        ) : (
          <Button type='button' customClassName={'btn-attach-file'} onClick={handleShowUploadTab}>
            {UI_CONSTANT.ATTACH_FILES}
          </Button>
        )}
        {values.modules[moduleIndex].topic.length > 1 && (
          <img
            className='delete-icon'
            src={deleteIcon}
            onClick={() => {
              remove(index)
              id && dispatch(deleteModulesAndTopics({ id: currentTopicId, type: 'topic' }))
            }}
          />
        )}
      </InputWithoutBorder>

      {showUploadTab && (
        <div className='tabs-container'>
          <div className='topic-course-divider' />
          <CustomTabs tabs={tabs} />
        </div>
      )}
    </div>
  )
}

export default AddCourseTopic
